import { goalCyclesConfig, propertyType } from 'shared/constants.json';
import { uniqBy } from 'lodash-es';

/**
 * Decides whether a goal passes the check-in template's team filter.
 *
 * The team filter is a no-op when no teams are configured. Otherwise a goal
 * matches when any of its space-type property values references one of the
 * configured teams.
 *
 * @param {{ properties: Array }} goal
 * @param {string[]} teamIds uids of the teams configured on the template
 * @returns {boolean}
 */
export const goalMatchesTeams = (goal, teamIds) => {
  if (teamIds.length === 0) {
    return true;
  }

  return goal.properties
    .filter((pv) => pv.property.type === propertyType.space)
    .flatMap((pv) => pv.spaces.map((s) => s.uid))
    .some((spaceId) => teamIds.includes(spaceId));
};

const intersectsByUid = (goalCycles, cycles) => goalCycles.some((cycle) => cycles.some((c) => c.uid === cycle.uid));

const cyclesForConfig = (config, ctx) => {
  if (config === goalCyclesConfig.current) {
    return ctx.currentGoalCycles;
  }

  if (config === goalCyclesConfig.past) {
    return ctx.pastGoalCycles;
  }

  if (config === goalCyclesConfig.userPreferences) {
    return ctx.selectedGoalCycles;
  }

  return [];
};

const goalMatchesCycleConfig = (goalCycles, config, ctx) => {
  if (goalCycles.length === 0) {
    return config === goalCyclesConfig.userPreferences && ctx.unassignedGoalCycleSelected;
  }

  return intersectsByUid(goalCycles, cyclesForConfig(config, ctx));
};

export const goalMatchesCycleConfigs = (goalCycles, configs, ctx) => configs.some((config) => goalMatchesCycleConfig(goalCycles, config, ctx));

export const goalCyclesForConfigs = (configs, ctx) => uniqBy(configs.flatMap((config) => cyclesForConfig(config, ctx)), 'uid');
